import Axios from "./axios";

const MAX_CONSEQUENT_ERROR_POLL_ATTEMPTS = 3;

/** Long Running Operation request (accepts Axios.post() arguments) */ 
export const LRORequestPost = async (url, data, config) => {
  let resp = await Axios.post(url, data, config);
  if (resp.status !== 202 || !resp.data.requestId) {
    return resp; // Operation completed
  }
  const requestId = resp.data.requestId;

  const startedAt = Date.now();
  let errorCount = 0;
  while (true) {
    // Polling delay
    await new Promise(r => setTimeout(r, getNextPollingDelayMs(startedAt)));

    try {
      resp = await Axios.post(url, { requestId }, config);
      errorCount = 0;
    } catch (error) {
      if (error?.response?.status && error.response.status >= 300) {
        throw error; // Server error, rethrow
      }
      // Retry on network error
      if (errorCount++ >= MAX_CONSEQUENT_ERROR_POLL_ATTEMPTS) {
        throw error; // Too many errors, rethrow
      }
      continue; // Retry
    }

    if (resp.status !== 202) {
      break; // Operation completed
    }
  }

  return resp;
};

/** Returns 1000..8188 (ms) for 0..3600 (sec) elapsed time */
const getNextPollingDelayMs = (startedAt) => {
  const elapsedSec = (Date.now() - startedAt) / 1000;
  const l = Math.log(elapsedSec); // Increase delay logarithmically
  const delayMs = Math.floor((l > 1 ? l : 1) * 1000); // Minimal delay is 1 sec
  return delayMs;
}
